/**
 * Standardized file type identifiers following MANUFACTURER_PRODUCT_FILETYPE convention
 * 
 * ⚠️  SINGLE SOURCE OF TRUTH: This array is the ONLY place to define file types.
 * ⚠️  DO NOT create manual union types - the WaveFileType is auto-generated from this array.
 * ⚠️  TO ADD NEW FILE TYPES: Add them to this array only, not anywhere else.
 * 
 * Naming Rules:
 * 1. All file types must include manufacturer prefix
 * 2. Clear product name in the middle  
 * 3. Descriptive file type at the end
 * 4. Single-file products use _DEFAULT suffix
 * 5. Use underscores, all caps, descriptive names
 */
export const WAVE_FILE_TYPES = [
  // Erdos Miller - MicroPulse
  'EM_MICROPULSE_FLOW',
  'EM_MICROPULSE_PULSE',
  'EM_MICROPULSE_ROTGAMMA',
  'EM_MICROPULSE_SURVEY',
  'EM_MICROPULSE_VIBE',
  'EM_MICROPULSE_DEBUG',
  'EM_MICROPULSE_GAMMA',
  'EM_MICROPULSE_TEMP',
  'EM_MICROPULSE_VOLTAGES',
  'EM_MICROPULSE_ROUTE',
  'EM_MICROPULSE_SYSTEM',
  'EM_MICROPULSE_TELEM',
  'EM_MICROPULSE_CONFIG',
  'EM_MICROPULSE_CONTINUOUS_MEAS',
  'EM_MICROPULSE_SHOCK',
  'EM_MICROPULSE_SHOCK_VIBE',
  'EM_MICROPULSE_RSS',
  'EM_MICROPULSE_SHOCKVIBE',
  
  // Erdos Miller - Cortex
  'EM_CORTEX_SURVEY',
  'EM_CORTEX_GYRO_CONTINUOUS_MEAS',
  'EM_CORTEX_GYRO_SURVEY',
  'EM_CORTEX_RAWSUR_F3',
  'EM_CORTEX_RAWSUR_SEC',
  'EM_CORTEX_SURVEY_SECONDARY',
  'EM_CORTEX_SYSTEM',
  'EM_CORTEX_VOLTAGES',
  
  // Erdos Miller - Eclipse Touch
  'EM_ECLIPSE_TOUCH_DECODE',
  
  // Erdos Miller - HopRx
  'EM_HOPRX_ICRUISE',
  'EM_HOPRX_VOLTAGES',
  'EM_HOPRX_RXLOG',
  
  // Erdos Miller - HopTx
  'EM_HOPTX_SYSTEM',
  'EM_HOPTX_TX',
  'EM_HOPTX_VOLTAGES',

  // Erdos Miller - HASS Logger
  'HASS_Logger',
  
  // JAE - Smart DM
  'JAE_SMARTDM_SURVEY',
  'JAE_SMARTDM_TELEM',
  'JAE_SMARTDM_GAMMA',
  'JAE_SMARTDM_TEMP',
  'JAE_SMARTDM_VOLTAGES',
  'JAE_SMARTDM_PULSE',
  'JAE_SMARTDM_ROUTE',
  'JAE_SMARTDM_ROTATION',
  'JAE_SMARTDM_ROTGAMMA',
  'JAE_SMARTDM_SHKVIBE',
  'JAE_SMARTDM_DEBUG',
  'JAE_SMARTDM_SYSTEM',
  'JAE_SMARTDM_ERROR',
  
  // D-Tech - Consolidated universal file types
  'DTECH_RSS_DEFAULT', // Legacy format (kept for compatibility)
  'DTECH_FDATA',
  'DTECH_TURBINE',
  'DTECH_COMPLETE_LOG',
  'DTECH_CUSTOMER_DATA',
  'DTECH_DOWNLINKS',
  
  // RIME - Pulser Driver
  'RIME_PULSER_DRIVER_DEFAULT',
  
  // Other Manufacturers (single file type products use _DEFAULT)
  'VERTEX_PULSER_DEFAULT',
  'INNOVA_BATTERY_DEFAULT', 
  'PROD_PULSER_DEFAULT',
  
  // Pason
  'PASON_EDR_DEFAULT',
  
  // LAS (Log ASCII Standard) - Well logging data
  'LAS_DRILLING_DEFAULT',
  
  // Generic CSV files (fallback parser)
  'GENERIC_CSV_TIMESERIES',
  
  // Phoenix Velocity (EVO logs)
  'PHX_VELOCITY_DEFAULT'
] as const

/**
 * Auto-generated union type from WAVE_FILE_TYPES array above.
 * ⚠️  DO NOT EDIT THIS TYPE MANUALLY - it's automatically derived.
 * ⚠️  TO ADD FILE TYPES: Add them to the WAVE_FILE_TYPES array above only.
 */
export type WaveFileType = typeof WAVE_FILE_TYPES[number]

 
